import axios from "axios";

// Same-origin by default (works on appistry.tech, appistry-merged.emergent.host,
// and the preview URL without needing REACT_APP_BACKEND_URL to be set correctly).
// Only use REACT_APP_BACKEND_URL when it points to a DIFFERENT origin than the current
// page — e.g. local dev where the React dev server is on :3000 but the API is on :8001.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";
const SAME_ORIGIN = typeof window !== "undefined" && ENV_URL && ENV_URL.replace(/\/$/, "") === window.location.origin;
const BACKEND_URL = ENV_URL && !SAME_ORIGIN ? ENV_URL.replace(/\/$/, "") : "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
